/**
 * The blog's section fronts, on the app side (ROADMAP `/blog/international/asx`).
 * The backend's twin is `functions/services/blog_sections.py`; the keys must
 * match (`market=international|asx`) — `blogSectionsParity.test.ts` pins it.
 */
/** A section front of the blog (ROADMAP `/blog/international/asx`): a LISTING
 *  of letters, each still at its one `/blog/<date>/<slug>` address. The heading
 *  is the market token, the same word as its URL segment (owner, 2026-09-25:
 *  "use market as section, not location"). */
export interface BlogSection {
  market: 'international' | 'asx';
  basePath: string;
  heading: string;
  intro: string;
}

export const BLOG_SECTIONS: Record<BlogSection['market'], BlogSection> = {
  international: {
    market: 'international',
    basePath: '/blog/international',
    heading: 'International',
    intro: 'Letters that cover companies listed outside the US.',
  },
  asx: {
    market: 'asx',
    basePath: '/blog/international/asx',
    heading: 'ASX',
    intro: 'Letters that cover companies listed on the Australian Securities Exchange.',
  },
};

